import React from "react";
import { Typography } from "antd";
import LandingTemplate from "../../../Layouts/LandingTemplate";
import { _t } from "../../../Common/components/InjectIntlContext";
import { useHistory } from "react-router-dom";
import CustomButton from "../../../Common/components/CustomButton";
const CommissionPage = ({ title, icon, items }) => {
  const history = useHistory();
  const translatedPoints = items(_t);
  const listItem = (item, idx) => <li key={idx}>{item}</li>;
  return (
    <LandingTemplate wrapClass="main-wrap--inner">
      <section className="commission-page custom-section custom-section--no-indent">
        <div className="container">
          <div className="commission-page__card">
            <h2 className="custom-section__title">{title}</h2>
            <ul className="commission-page__list">
              {translatedPoints.map(listItem)}
            </ul>
            <CustomButton
              onClick={() => history.goBack()}
              className="btn--border"
              btnLabel={_t("Back")}
            />
          </div>
        </div>
      </section>
    </LandingTemplate>
  );
};

export default CommissionPage;
